<template>
      <div no-body class="lku-bakerysalesbinder"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
              <b-col cols="6">
                <b-input-group >
                  <b-input-group-prepend><span class="pt-2 pr-1">Filter</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.CustName" placeholder="Customer Name" @keyup.13.native="refresh()"></b-form-input>
                </b-input-group >
              </b-col>
              <b-col cols="6">
                <b-input-group >
                  <b-input-group-prepend><span class="p-2">Tgl. Laporan</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.tgl1" type="date" class="ml-1"></b-form-input>
                  <b-button class="btn btn-success ml-2 mr-1" @click="search()" > <i class="fa fa-refresh"></i> Apply </b-button>
                  <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear</b-button>
                </b-input-group>
              </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblOrder" style="font-size:smaller;" 
          responsive small striped hover
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(tanggal)="data">{{ data.item.tanggal | moment('YYYY-MM-DD')}}</template>
        <template v-slot:cell(ttlgross)="data">{{ data.item.ttlgross | numFormat }}</template>
        <template v-slot:cell(ttldiskon)="data">{{ data.item.ttldiskon | numFormat }}</template>
        <template v-slot:cell(ttlnetto)="data">{{ data.item.ttlnetto | numFormat }}</template>
        <template v-slot:cell(ttlJudul)="data">{{ data.item.ttlJudul | numFormat }}</template>
        <template v-slot:cell(ttlQty)="data">{{ data.item.ttlQty | numFormat }}</template>
        <template v-slot:cell(delverJudul)="data">{{ data.item.delverJudul | numFormat }}</template>
        <template v-slot:cell(deliverQty)="data">{{ data.item.deliverQty | numFormat }}</template>
        </b-table>
        <b-row>
          <b-col cols="6">
            <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to
              <span
                v-if="((tblData.page * tblData.limit)>tblData.total)"
              >{{tblData.total}}</span>
              <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total | numFormat}} entries,
              <span
                class="ml-3 mr-1"
              >limit per page :</span>
              <select v-model="tblData.limit" style="width:60px;">
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>30</option>
              </select>
            </div>
          </b-col>
          <b-col cols="6">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
  </div>
</template>
<style lang="scss">
  .lku-bakerysalesbinder {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import bakerysales from "../../apis/bakerysales";

export default {
  data() {
    return {
      fields: [
          {
            key: "CustName",
            label: "Customer/Group",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Tgl. Laporan",
            sortable: true
          },
          {
            key: "uraian",
            label: "Keterangan",
            sortable: true
          },
          {
            key: "Total",
            label: "Total Penjualan",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'CustName',
        sortDesc: false,
      },
      lkuLoading:false
    };
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await bakerysales.listbinder(this.tblData);      
      this.lkuLoading=false;
      return list;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
      this.tblData.customer = "";
      this.tblData.customer_id = "";
      this.tblData.Advertiser = "";
      this.tblData.campaign = "";
      this.tblData.campaignKey = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.ExtrDocNo = "";
      this.tblData.sales_search = "";
      // this.refresh();
    },    
    keymonitor: function(event) {
        console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblOrder.refresh();
       }
    },    
    refresh() {
      this.$refs.tblOrder.refresh();
    }
  }
};
</script>
